import {Pipe, PipeTransform} from "@angular/core";
import * as moment from "moment";

@Pipe({name: "formatDuration"})
export class FormatDurationPipe implements PipeTransform {
  public transform(durationHours: number): string {
    let durationText = "";
    if (durationHours !== undefined) {
      let duration = moment.duration(durationHours, "hours");
      let days = Math.floor(duration.asDays());
      let hours = duration.hours();
      let minutes = duration.minutes();
      if (days) {
        if (days <= 1) {
          durationText = `${days} day `;
        } else {
          durationText = `${days} days `;
        }
      }

      if (hours <= 1) {
        durationText += `${hours} hour`;
      } else {
        durationText += `${hours} hours`;
      }

      if (minutes <= 1 && minutes > 0) {
        durationText += ` ${minutes} minute`;
      } else if (minutes > 1) {
        durationText += ` ${minutes} minutes`;
      }

    }
    return durationText;

  }
}



// WEBPACK FOOTER //
// ./client/app/pipes/format-duration.pipe.ts